import { createSelector } from 'reselect'
import { getProjectRoles } from './project.selector'
import { Roles } from '../utils/Roles'

export const getCurrentUserId = state => state.firebase.auth.uid

export const getCurrentUserRole = createSelector ([getProjectRoles, getCurrentUserId], (roles, currentUserId) => {
    return !!roles[currentUserId]
        ? roles[currentUserId].type
        : Roles.ADMIN
})

export const isAdmin = createSelector ([getCurrentUserRole], (role) => {
    return role === Roles.ADMIN
})

export const isFormDisabled = createSelector([getCurrentUserRole], (currentUserRole) => Roles.VIEWER === currentUserRole)



// WEBPACK FOOTER //
// ./src/selectors/user.selector.tsx